import {like_action} from "../actions/like";


const inited = {
    id: null,
    selected: null,
    callback: null,
};

export default function likeReducer(state = inited, action) {
    switch (action.type) {
        case like_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/like.js